var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" Error 404: No se pudo encontrar la página solicitada. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }